import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';

import * as SearchAction from 'store/search/action';
import * as Action from 'store/menu/action';
import * as css from './css/hot-word';

function HotWord(props) {
  const {
    className,
    hotWordList,
    fetchHotWordList,
    searchAction,
    onSearch
  } = props;

  let history = useHistory();
  let location = useLocation();

  useEffect(() => {
    fetchHotWordList();
  }, []);

  function doSearch(hotWord) {
    searchAction.setKeyword(hotWord);
    onSearch();
  }

  function renderList() {
    return hotWordList.map(item => {
      const { id, hotWord } = item;

      return (
        <a
          key={id}
          className='hot-word'
          onClick={(e) => {
            e.preventDefault();
            doSearch(hotWord);
          }}
          href='#'
        >
          {hotWord}
        </a>
      );
    });
  }

  return (
    <css.HotWord className={className}>
      <css.List>{renderList()}</css.List>
    </css.HotWord>
  );
}

export default connect(
  state => {
    const { menu } = state;
    const { hotWordList } = menu;

    return {
      hotWordList
    };
  },
  f => ({
    fetchHotWordList() {
      f(Action.fetchHotWordList(...arguments));
    },
    searchAction: {
      setKeyword() {
        f(SearchAction.setKeyword(...arguments));
      }
    }
  })
)(HotWord);
